import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';

import './styles.css';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import TituloPagina from '../Includes/Titulos';
import api from '../../services/api';
import { useTranslation } from 'react-i18next';


export default function Payment() {
    const { t } = useTranslation();
    const history = useHistory();
    const BASE_URL = 'https://agrobrazilapp.com/';
    const USER_EMAIL = sessionStorage.getItem('email');
    const USER_TOKEN = sessionStorage.getItem('token');
    const selectedPlan = JSON.parse(sessionStorage.getItem('selectedPlan'))
    const payforms = [t('pages.paymentMethod.payForms.credCard')];

    var FormData = require('form-data');
    var data = new FormData();
    data.append('USER_TOKEN', USER_TOKEN);
    data.append('USER_EMAIL', USER_EMAIL);

    const axios = require('axios');
    useEffect(() => {
        api.get(`${BASE_URL}/v4/users/me/subscriptions`, {
            headers: {
                'USER_EMAIL': USER_EMAIL,
                'USER_TOKEN': USER_TOKEN,
            }
        }).then(response => {

        }).catch(err => {
            if (err.status === 401) {
                history.push('/');
            }
        });

        var config = {
            method: 'get',
            url: ` ${BASE_URL}`,
            headers: {
                'Content-Type': 'application/json',
                'USER_TOKEN': USER_TOKEN,
                'USER_EMAIL': USER_EMAIL
            }
        };

        axios(config)
            .then(function (response) {

                console.log(response.data);



            })
            .catch(function (error) {
                console.log(error);
            });

    }, [USER_EMAIL, USER_TOKEN, history]);
    function getPaymentForm(id) {
        sessionStorage.setItem('paymentForm', JSON.stringify(id));
    }
class PayForm extends React.Component{
    render(){
        return(
            <div>
            <form id="payment-form"  action="/checkout/endereço">
        {payforms.map(payform => (
            
                <li key={payform} class="list-input-style">
                    
                    <label>
                    <div class="borderinputs">
                        <input required class="input-solver" id={payform} type="radio" name="paymentmethod" onClick={() => {
                            getPaymentForm(payform);
                        }} id={payform} value={payform} />{payform}
                         </div>
                    </label><br />
                   
                </li>

        ))}
        <button class="btn-payment" > {t('commons.buttons.next')} </button>
        </form>
        </div>
        );
    };
}
    return (

        <div class="payment-container">
            <Header />
            <button class="btn-voltar" onClick={() => { history.go(-1) }}>  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14 arruma-arrow" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path></svg> </button><div class="alinha-titulo" ><TituloPagina titulo={t('pages.paymentMethod.title')} /></div>
            <div class="bodypayment ">

                    <h4 class="plan-name">{selectedPlan.name} - {selectedPlan.price}</h4>
                    <p> {t('pages.paymentMethod.monthly')} </p>
                    <PayForm />
                    <ul>
                       
</ul>
            </div>
            <Footer />
        </div>
    );
}
